"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var composition_api_1 = require("@vue/composition-api");
var store_1 = require("../store");
var i18n_1 = require("../i18n");
var client_checker_1 = require("../client-checker");
var router_1 = require("../router");
var componentName = 'Consent';
exports.default = composition_api_1.defineComponent({
    name: componentName,
    setup: function (context) {
        var _this = this;
        var store = store_1.getStore(), _a = router_1.useRouter(), router = _a.router, route = _a.route, i18n = i18n_1.useI18n();
        var client = client_checker_1.useClientChecker();
        var state = composition_api_1.reactive({
            consentInfo: null,
            consentProgress: false,
            form: {
                privacy: false,
            },
        });
        var showConsentScopesCheckboxList = composition_api_1.computed(function () {
            return !(client.clientIsGoogleBliss.value ||
                client.clientIsGoogleYesly.value ||
                client.clientIsAlexaBliss.value ||
                client.clientIsAlexaYesly.value ||
                client.clientIsAlexaYou.value ||
                client.clientIsGoogleYou.value ||
                client.clientIsIftttYou.value);
        });
        var notificationTitle = composition_api_1.ref('');
        var notificationSubTitle = composition_api_1.ref('');
        if (client.clientIsGoogleYesly.value) {
            notificationTitle.value = i18n.t('accessConsentNotificationGoogleTitle');
            notificationSubTitle.value = i18n.t('accessConsentNotificationGoogleYeslySubTitle');
        }
        else if (client.clientIsAlexaYesly.value) {
            notificationTitle.value = i18n.t('accessConsentNotificationAlexaTitle');
            notificationSubTitle.value = i18n.t('accessConsentNotificationAlexaYeslySubTitle');
        }
        else if (client.clientIsGoogleBliss.value) {
            notificationTitle.value = i18n.t('accessConsentNotificationGoogleTitle');
            notificationSubTitle.value = i18n.t('accessConsentNotificationGoogleBlissSubTitle');
        }
        else if (client.clientIsAlexaBliss.value) {
            notificationTitle.value = i18n.t('accessConsentNotificationAlexaTitle');
            notificationSubTitle.value = i18n.t('accessConsentNotificationAlexaBlissSubTitle');
        }
        else if (client.clientIsAlexaYou.value) {
            notificationTitle.value = i18n.t('accessConsentNotificationAlexaTitle');
            notificationSubTitle.value = i18n.t('accessConsentNotificationAlexaYouSubTitle');
        }
        else if (client.clientIsGoogleYou.value) {
            notificationTitle.value = i18n.t('accessConsentNotificationGoogleTitle');
            notificationSubTitle.value = i18n.t('accessConsentNotificationGoogleYouSubTitle');
        }
        else if (client.clientIsIftttYou.value) {
            notificationTitle.value = i18n.t('accessConsentNotificationIftttTitle');
            notificationSubTitle.value = i18n.t('accessConsentNotificationIftttYouSubTitle');
        }
        else {
            notificationTitle.value = i18n.t('accessConsentNotificationGenericTitle');
            if (!showConsentScopesCheckboxList.value) {
                notificationSubTitle.value = i18n.t('accessConsentNotificationGenericSubTitle');
            }
        }
        var clientId = route.value.query.client_id;
        var returnUrl = route.value.query.returnUrl;
        if (returnUrl) {
            store.dispatch('consentInfo', { returnUrl: returnUrl })
                .then(function (response) {
                if (response.result == 'OK') {
                    if (response.data.identityScopes) {
                        response.data.identityScopes.forEach(function (e) { return e['checked'] = false; });
                    }
                    if (response.data.resourceScopes) {
                        response.data.resourceScopes.forEach(function (e) { return e['checked'] = false; });
                    }
                    state.consentInfo = response.data;
                }
            });
        }
        var onAllow = function () { return __awaiter(_this, void 0, void 0, function () {
            var scopesConsented, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        scopesConsented = [];
                        if (showConsentScopesCheckboxList.value) {
                            if (state.consentInfo.identityScopes) {
                                scopesConsented = scopesConsented.concat(state.consentInfo.identityScopes.filter(function (s) { return s.checked; }).map(function (s) { return s.name; }));
                            }
                            if (state.consentInfo.resourceScopes) {
                                scopesConsented = scopesConsented.concat(state.consentInfo.resourceScopes.filter(function (s) { return s.checked; }).map(function (s) { return s.name; }));
                            }
                        }
                        else {
                            scopesConsented = ['openid', 'api.v1.2.google-actions', 'api.v1.2.alexa-actions', 'offline_access', 'api.v1.2.ifttt-actions'];
                        }
                        if (!returnUrl) return [3 /*break*/, 2];
                        state.consentProgress = true;
                        return [4 /*yield*/, store.dispatch('consent', {
                                scopesConsented: scopesConsented,
                                returnUrl: returnUrl
                            })];
                    case 1:
                        response = _a.sent();
                        state.consentProgress = false;
                        if (response.result == 'OK') {
                            window.location.href = response.data.next;
                            return [2 /*return*/];
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        var onDeny = function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!returnUrl) return [3 /*break*/, 2];
                        state.consentProgress = true;
                        return [4 /*yield*/, store.dispatch('consent', {
                                scopesConsented: [], returnUrl: returnUrl
                            })];
                    case 1:
                        response = _a.sent();
                        state.consentProgress = false;
                        if (response.result == 'OK') {
                            window.location.href = response.data.next;
                            return [2 /*return*/];
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        var signinRoute = composition_api_1.computed(function () {
            return { name: 'access-signin', query: route.value.query };
        });
        var consentScopeDisplayText = function (consentScope) {
            if (!consentScope.name) {
                return consentScope.displayName;
            }
            var key = "accessConsent" + consentScope.name[0].toLocaleUpperCase() + consentScope.name.substring(1);
            return i18n.te(key) ? i18n.t(key) : consentScope.displayName;
        };
        var allowDisabled = composition_api_1.computed(function () {
            if (showConsentScopesCheckboxList.value) {
                if (state.consentInfo && state.consentInfo.identityScopes &&
                    state.consentInfo.identityScopes.some(function (s) { return s.required && !s.checked; })) {
                    return true;
                }
                if (state.consentInfo && state.consentInfo.resourceScopes &&
                    state.consentInfo.resourceScopes.some(function (s) { return s.required && !s.checked; })) {
                    return true;
                }
            }
            return false;
        });
        var privacyPolicyHref = composition_api_1.computed(function () { return i18n_1.getPrivacyPolicyLocalizedUrl(i18n.locale); });
        return {
            state: state,
            onAllow: onAllow,
            onDeny: onDeny,
            notificationTitle: notificationTitle,
            notificationSubTitle: notificationSubTitle,
            signinRoute: signinRoute,
            consentScopeDisplayText: consentScopeDisplayText,
            allowDisabled: allowDisabled,
            showConsentScopesCheckboxList: showConsentScopesCheckboxList,
            privacyPolicyHref: privacyPolicyHref,
        };
    }
});
